export const serializeParamsWithArray = (
  params: Record<string, unknown>,
  arrayFormat: 'repeat' | 'comma' = 'repeat'
) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (arrayFormat === 'comma') {
        searchParams.append(key, value.map(String).join(','));
      } else {
        value.forEach((item) => searchParams.append(key, String(item)));
      }
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
};
